
export interface Processo {
    id?: number,
    numero_processo?: string,
    descricao?: string,
    route?: string,
    tipo_processo?: string,
    atividade_atual?: string,
    data_recebimento?: string,
    data_recebimento_dias?: string,
    orgao_origem?: string,
    orgao_portador?: string,
    pf_processo_vinculo?: Vinculo[]
}
export interface Vinculo {
    id?: number,
    tipo_vinculacao?:number,
    item_id?:number
}
export interface ComboVinculo {
    1?: Combo[], //issue
    2?: Combo[], //indicator
    3?: Combo[], //irfe
    4?: Combo[] //ircp
}

export interface Combo {
    id?: number,
    label?:string
}
export interface TipoVinculacao{
    id?: number,
    label?: string,
    route?: string,

}
export enum TipoVinculacaoData {
  Entrega = 1,
  Indicador = 2,
  IRFE = 3,
  IRCP = 4,
}

export const TipoVinculacaoOptions:TipoVinculacao[] = [
  { id: TipoVinculacaoData.Entrega, label: 'Item do Cronograma', route: 'entregas' },
  { id: TipoVinculacaoData.Indicador, label: 'Indicador', route: 'indicadores' },
  { id: TipoVinculacaoData.IRFE, label: 'IRFE', route: 'irfe' },
  { id: TipoVinculacaoData.IRCP, label: 'IRCP', route: 'ircp' },
];